import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import ScanUserDetail from './ScanUserDetail';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyScanUserDetail } from './companyScanApi';

/**
 * Company Scans → one employee's/member's scan history.
 * Reuses the shared detail page with the company-scoped fetcher (the backend
 * 404s any user who doesn't belong to this company).
 */
const CScanUserDetail = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>User Scans | Shoorah</title>
      </Helmet>
      <ScanUserDetail
        fetcher={fetchCompanyScanUserDetail}
        backPath={`/${slug}/scans/users`}
        backLabel={isB2BFansMode ? 'Back to Members' : 'Back to Employees'}
      />
    </div>
  );
};

export default CScanUserDetail;
